import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { asset } from '../data/redesignAssets';
import { DEMO_URL, SIGN_IN_URL } from '../data/links';
const ROUTES: ReadonlyArray<{
  to: string;
  label: string;
}> = [{
  to: '/how',
  label: 'How it works'
}, {
  to: '/blog',
  label: 'Blog'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return <nav className="nav bleed" aria-label="Main" data-id="element-251" data-mp="1pqjse8j8tnt1">
      <Link className="logo" to="/" data-id="element-252" data-mp="1pruvs78s0tjm">
        <img src={asset('meetsynthia-logo-lockup.svg')} alt="meetsynthia" data-id="element-253" data-mp="1uov12fxsxs9o" />
      </Link>

      <div className="nav-r" data-id="element-254" data-mp="1yqowa8p8a42g">
        {ROUTES.map(r =>
      // NavLink matches descendants, so Blog stays active on /blog/:slug.
      <NavLink key={r.to} to={r.to} data-label={r.label} className={({
        isActive
      }) => `nav-link${isActive ? ' active' : ''}`} data-id="element-255" data-mp="23pt9rbj6qnyl">
            {r.label}
          </NavLink>)}
        <a className="nb nb-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-256" data-mp="1u3k4v39wyn4x">
          Book a demo
        </a>
        {/* target="_top" so it leaves an embedded preview instead of loading inside it. */}
        <a className="nb nb-o" href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-257" data-mp="1k7gzzpnogaea">
          Sign in
        </a>
      </div>

      <button type="button" className="navtoggle" aria-expanded={open} aria-controls="nav-panel" onClick={() => setOpen(v => !v)} data-id="element-258" data-mp="2hw0lrahx092n">
        {open ? <XIcon size={16} aria-hidden="true" data-id="element-259" data-mp="282a1yiwqgmta" /> : <MenuIcon size={16} aria-hidden="true" data-id="element-260" data-mp="235b7fz95qduk" />}
        {open ? 'Close' : 'Menu'}
      </button>

      {open && <div className="navpanel" id="nav-panel" data-id="element-261" data-mp="30kp35mh6vw9o">
          {ROUTES.map(r => <NavLink key={r.to} to={r.to} className="nl" data-id="element-262" data-mp="2vtyy6acodvfi">
              {r.label}
            </NavLink>)}
          <div className="pb" data-id="element-263" data-mp="tvwwos2hvo39">
            <a className="nb nb-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-264" data-mp="twori0o9phsh">
              Book a demo
            </a>
            <a className="nb nb-o" href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-265" data-mp="xzl4nbv1glp1">
              Sign in
            </a>
          </div>
        </div>}
    </nav>;
}